import { useSuspenseQuery } from '@tanstack/react-query';

import { productsManagementQueries } from '@/activityLog/productsManagement/queries/productsManagementQueries.ts';
import { useAtomValue } from 'jotai';
import {
  productsManagementFiltersAtom,
  productsManagementPageFilterAtom,
  productsManagementRowsPerPageFilterAtom,
} from 'atoms/filters/products-management-filters.ts';
import { useDebounce } from 'common/useDebounce.ts';
import { fetchProductManagement } from '@/activityLog/productsManagement/productManagementApi/productsManagementApi.ts';

export const useProductsManagementFetch = () => {
  const page = useAtomValue(productsManagementPageFilterAtom);
  const pageSize = useAtomValue(productsManagementRowsPerPageFilterAtom);
  const filters = useAtomValue(productsManagementFiltersAtom);

  const { status, uploadDateFrom, uploadDateTo, fileName } = filters;
  const from = uploadDateFrom ? new Date(uploadDateFrom) : null;
  const to = uploadDateTo ? new Date(uploadDateTo) : null;

  const debouncedFileName = useDebounce(fileName, 200);
  return useSuspenseQuery({
    queryKey: productsManagementQueries.list({
      fileName: debouncedFileName,
      uploadDateFrom: from,
      uploadDateTo: to,
      status,
      page,
      pageSize,
    }),
    queryFn: () => {
      return fetchProductManagement({
        fileName: fileName,
        page: page,
        pageSize: pageSize,
        status: status,
        uploadDateFrom: from,
        uploadDateTo: to,
      });
    },
  });
};
